/*
 * Custom rules for basement windows
 */
class BasementWindowRulesService {
    constructor() {
        this.heightLimit = 580;
        this.widthLimit = 580;
    }

    areConditionsMet(width, height) {
        return this.isHeightBelowLimit(height) || this.isWidthBelowLimit(width);
    }

    isHeightBelowLimit(height) {
        return this.heightLimit > height;
    }

    isWidthBelowLimit(width) {
        return this.widthLimit > width;
    }
}

export default angular.module('basementWindowRulesService', [])
    .service('basementWindowRulesService', BasementWindowRulesService)
    .name;
